export default "__VITE_ASSET__pWDQAJOf__"